import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";
import RibbonNavbar from "../../components/RibbonNavbar";
import { useParams } from "react-router-dom";
import { iepaProd } from "../../constants/global";

const ImportedData = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { requestNumber } = useParams();

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  // ✅ Fetch data from API
  const fetchData = async () => {
  setLoading(true);
  try {
    const crn = requestNumber; // You can also get this dynamically from useParams()
    const org_id = 1;

    const response = await fetch(
      `${iepaProd.iepaCollectionSrvAPI}/collection/interface/crn/${crn}/org/${org_id}`,
      {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (Array.isArray(data)) {
      // 🧩 Convert array into DataGrid format
      const formattedRows = data.map((row, index) => ({
        id: row.id || index + 1,
        ...row,
      }));

      // 🧱 Dynamically create columns
      const formattedColumns = Object.keys(data[0] || {}).map((key) => ({
        field: key,
        headerName: key.replace(/([A-Z])/g, " $1").toUpperCase(),
        flex: 1,
      }));

      setColumns(formattedColumns);
      setRows(formattedRows);
    } else {
      console.error("Unexpected API format", data);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    fetchData();
  }, []);

  const handleRowEditCommit = (updatedRow) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === updatedRow.id ? { ...row, ...updatedRow } : row
      )
    );
  };

  const handleDeleteFromRibbon = () => {
    setOpenConfirmDialog(true);
  };

  const confirmDelete = () => {
    setRows((prevRows) => prevRows.filter((row) => !selectedRows.includes(row.id)));
    setSelectedRows([]);
    setOpenConfirmDialog(false);
  };

  const cancelDelete = () => {
    setOpenConfirmDialog(false);
  };

  return (
    <Box px={1} padding={1}>
      {/* Header and RibbonNavbar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Header title="Route Detail Report" subtitle={`Data of Upload ID ${requestNumber}`} />
        <RibbonNavbar
          showEdit
          showDelete
          onEdit={() => { }}
          onDelete={handleDeleteFromRibbon}
          disabledEdit={selectedRows.length !== 1}
          disabledDelete={selectedRows.length === 0}
        />
      </Box>

      <Box
        height="78vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": {
            borderBottom: "1px solid grey",
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
            fontSize: "14px",
          },
          "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
            height: "5vh",
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          checkboxSelection
          loading={loading}
          processRowUpdate={handleRowEditCommit}
          onRowSelectionModelChange={(newSelection) => setSelectedRows(newSelection)}
          components={{ Toolbar: GridToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>

      {/* Delete Confirmation */}
      <Dialog open={openConfirmDialog} onClose={cancelDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {selectedRows.length} selected row(s)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ImportedData;
